// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3ATP7","header":"MessagesList_header__2IYbU","chat":"MessagesList_chat__149W2"};